require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./asia-gender-smart-investing-forum.json") })
        }
      }, "path---asia-gender-smart-investing-forum");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---asia-gender-smart-investing-forum!./.cache/json/asia-gender-smart-investing-forum.json
// module id = 1045
// module chunks = 231608221292675